/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_DomainInputs */

const en_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Domain`)
};

const es_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio de destino`)
};

const fr_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine cible`)
};

const de_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieldomain`)
};

const ja_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットドメイン`)
};

const zh_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标域名`)
};

const ar_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النطاق المستهدف`)
};

const id_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Target`)
};

const it_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio di Destinazione`)
};

const ru_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевой домен`)
};

const pt_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio de Destino`)
};

const ko_target_domain = /** @type {(inputs: Target_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대상 도메인`)
};

/**
* | output |
* | --- |
* | "Target Domain" |
*
* @param {Target_DomainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const target_domain = /** @type {((inputs?: Target_DomainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_DomainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_target_domain(inputs)
	if (locale === "es") return es_target_domain(inputs)
	if (locale === "fr") return fr_target_domain(inputs)
	if (locale === "de") return de_target_domain(inputs)
	if (locale === "ja") return ja_target_domain(inputs)
	if (locale === "zh") return zh_target_domain(inputs)
	if (locale === "ar") return ar_target_domain(inputs)
	if (locale === "id") return id_target_domain(inputs)
	if (locale === "it") return it_target_domain(inputs)
	if (locale === "ru") return ru_target_domain(inputs)
	if (locale === "pt") return pt_target_domain(inputs)
	return ko_target_domain(inputs)
});